module.exports = __webpack_public_path__ + "img/yyt4.d9c269df.png";